import { Box } from "@mui/joy";
import { useEffect } from "react";
import { Navigate, useNavigate, useRoutes } from "react-router-dom";
import { useOrganizationSelector } from "features/dmp";

enum DmpPages {
  AUDIENCES = "audiences",
  INSIGHTS = "insights",
  EXPORTS = "exports",
  ACTIVATION = "activation",
  CONFIGURATION = "configuration",
}

const DmpPage = () => {
  const navigate = useNavigate();
  const { selectedOrganizationId } = useOrganizationSelector();
  const element = useRoutes([
    { element: null, path: DmpPages.AUDIENCES },
    { element: null, path: DmpPages.INSIGHTS },
    { element: null, path: DmpPages.EXPORTS },
    { element: null, path: DmpPages.ACTIVATION },
    { element: null, path: DmpPages.CONFIGURATION },
    { element: <Navigate to={`/pap/${DmpPages.CONFIGURATION}`} />, path: "*" },
  ]);
  useEffect(() => {
    if (!selectedOrganizationId) {
      navigate("/pap/audiences");
    }
  }, [navigate, selectedOrganizationId]);
  return (
    <Box
      sx={{
        alignItems: "stretch",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "stretch",
      }}
    >
      {element}
    </Box>
  );
};

export default DmpPage;
